// extracted by mini-css-extract-plugin
export default {"layout":"SharedLayout_layout__eVkrW","header":"SharedLayout_header__HMjkG","main":"SharedLayout_main__ColIW"};